import { Pipe, PipeTransform } from '@angular/core';
import { AnyType } from '@thehubz/shared/model';

@Pipe({
  name: 'assetTypeToIconName',
  standalone: true,
})
export class AssetTypeToIconNamePipe implements PipeTransform {
  private assetIconMap: AnyType = {
    Image: 'image',
    PDF: 'picture_as_pdf',
    ZIP: 'folder_zip',
    Video: 'videocam',
    'Powerpoint presentation': 'auto_graph',
    'HTML Banner': 'html',
    Other: 'insert_drive_file',
    Audio: 'audio_file',
  };

  transform(value: string, ...args: unknown[]): string {
    let icon = '';

    if (this.assetIconMap[value]) {
      icon = this.assetIconMap[value];
    }

    return icon;
  }
}
